const id_master_goodsPrice = {
    "": "ubah harga",
}

export default id_master_goodsPrice;